import { Controller } from "@hotwired/stimulus"

// Substitui o handler jQuery global `btn-modal-abrir` (+ preparaModalSelecaoBase/
// preparaModalSelecao em functions.js). Abre o modal compartilhado (shared/modals/_base),
// carrega a lista de seleção via fetch e popula os campos id/nome do formulário.
//
// O conteúdo do modal vive fora do escopo deste controller (layout), por isso a
// vinculação de linhas/busca/paginação é feita programaticamente após cada fetch.
export default class extends Controller {
  static targets = ["idField", "nameField", "clearButton"]
  static values = {
    modulo: String,
    path: String,
    hash: { type: String, default: "" },
    querystring: { type: String, default: "" },
    // Quando presente, ao selecionar recarrega a página setando este param na URL
    // (mantendo os demais, ex.: admin_id). Usado pelo filtro de permissões.
    reloadParam: { type: String, default: "" },
    // CSV de params removidos da URL no reload (ex.: ao escolher admin, zera
    // estabelecimento_id e instituicao_id). Usado pelo filtro de permissões.
    reloadClear: { type: String, default: "" }
  }

  open(event) {
    event.preventDefault()

    const modal = document.querySelector(".modal")
    const content = document.querySelector(".modal-content")
    modal.classList.add("is-active")
    content.innerHTML = '<div class="modal-preloading">Carregando, aguarde...</div>'

    let url = `/${this.moduloValue}/${this.pathValue}?hash=true&modal=true`
    if (this.querystringValue) url += `&${this.querystringValue}`
    if (this.hashValue) url += `&${this.hashValue}`

    this._fetchHtml(url).then(html => {
      content.innerHTML = html
      this._bindContent(content)
      const term = content.querySelector("[data-modal-search-term]")
      if (term) term.focus()
    })
  }

  clear(event) {
    if (event) event.preventDefault()
    if (this.hasIdFieldTarget) this.idFieldTarget.value = ""
    if (this.hasNameFieldTarget) this.nameFieldTarget.value = ""
    if (this.hasClearButtonTarget) this.clearButtonTarget.classList.add("is-hidden")
  }

  // --- internos -----------------------------------------------------------

  _bindContent(content) {
    this._bindRows(content)
    this._bindSearch(content)
    this._bindPagination(content)
  }

  _bindRows(content) {
    content.querySelectorAll("[data-modal-row]").forEach(row => {
      row.addEventListener("click", () => this._select(row))
    })
  }

  _select(row) {
    if (this.hasIdFieldTarget) this.idFieldTarget.value = row.dataset.id || ""
    if (this.hasNameFieldTarget) this.nameFieldTarget.value = row.dataset.nome || ""
    if (this.hasClearButtonTarget) this.clearButtonTarget.classList.remove("is-hidden")
    this._close()

    if (this.reloadParamValue) {
      const url = new URL(window.location.href)
      url.searchParams.set(this.reloadParamValue, row.dataset.id || "")
      this.reloadClearValue.split(",").map(p => p.trim()).filter(Boolean)
          .forEach(param => url.searchParams.delete(param))
      window.location.assign(url.toString())
    }
  }

  _bindSearch(content) {
    const button = content.querySelector("[data-modal-search-button]")
    const term = content.querySelector("[data-modal-search-term]")
    const showAll = content.querySelector("[data-modal-show-all]")
    if (!button) return

    const run = () => this._search(content)
    button.addEventListener("click", event => { event.preventDefault(); run() })
    if (term) {
      term.addEventListener("keydown", event => {
        if (event.key === "Enter") { event.preventDefault(); run() }
      })
    }
    if (showAll) {
      showAll.addEventListener("click", event => {
        event.preventDefault()
        if (term) term.value = ""
        run()
      })
    }
  }

  _search(content) {
    const field = content.querySelector("[data-modal-search-field]")
    const criteria = content.querySelector("[data-modal-search-criteria]")
    const term = content.querySelector("[data-modal-search-term]")
    const params = new URLSearchParams({ modal: "true", ajax_html: "true" })
    if (field) params.set("campo", field.value)
    if (criteria) params.set("criterio", criteria.value)
    if (term) params.set("termo", term.value)

    const url = `/${this.moduloValue}/${this.pathValue}?${params.toString()}`
    this._fetchHtml(url).then(html => this._replaceResults(content, html, term))
  }

  _bindPagination(content) {
    const results = content.querySelector("[data-modal-results]")
    if (!results) return
    results.querySelectorAll("a[href]").forEach(link => {
      link.addEventListener("click", event => {
        event.preventDefault()
        this._fetchHtml(link.href).then(html => this._replaceResults(content, html))
      })
    })
  }

  _replaceResults(content, html, focusTerm) {
    const results = content.querySelector("[data-modal-results]")
    if (results) results.innerHTML = html
    this._bindRows(content)
    this._bindPagination(content)
    const showAll = content.querySelector("[data-modal-show-all]")
    if (showAll && focusTerm) showAll.classList.toggle("is-hidden", !focusTerm.value)
  }

  _fetchHtml(url) {
    return fetch(url, { headers: { "Accept": "text/html", "X-Requested-With": "XMLHttpRequest" } })
      .then(response => response.text())
  }

  _close() {
    const modal = document.querySelector(".modal")
    if (modal) modal.classList.remove("is-active")
  }
}
